type InlineStyle = Pick<
  CSSStyleDeclaration,
  'getPropertyValue' | 'getPropertyPriority' | 'setProperty' | 'removeProperty'
>;

interface DrawingViewport {
  readonly document: {
    readonly body: { readonly style: InlineStyle };
    readonly documentElement: { readonly style: InlineStyle };
  };
  readonly scrollX: number;
  readonly scrollY: number;
  scrollTo(options: ScrollToOptions): void;
}

/** Only used while the result-board brush is open, including native dialog on iPad. */
export function lockDrawingPageScroll(view: DrawingViewport = window): () => void {
  const { scrollX, scrollY } = view;
  const restores: (() => void)[] = [];
  const set = (style: InlineStyle, property: string, value: string) => {
    const previous = style.getPropertyValue(property);
    const priority = style.getPropertyPriority(property);
    restores.push(() => {
      if (previous) style.setProperty(property, previous, priority);
      else style.removeProperty(property);
    });
    style.setProperty(property, value);
  };
  const body = view.document.body.style;
  const root = view.document.documentElement.style;
  set(root, 'overflow', 'hidden');
  set(root, 'overscroll-behavior', 'none');
  set(body, 'position', 'fixed');
  set(body, 'top', `${-scrollY}px`);
  set(body, 'left', `${-scrollX}px`);
  set(body, 'width', '100%');
  set(body, 'overflow', 'hidden');
  let released = false;
  return () => {
    if (released) return;
    released = true;
    for (const restore of restores.reverse()) restore();
    view.scrollTo({ left: scrollX, top: scrollY, behavior: 'instant' });
  };
}
